import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'longText',
  standalone: true
})
export class LongTextPipe implements PipeTransform {

  transform(value: string, length = 12): string | null {
    if (value.length >= length) {
      return value.slice(0, length) + '..';
    } else {
      return value;
    }
  }

}
